export enum Products {
  ADMIN = 'Admin',
  CALENDAR = 'Calendar',
  REVENUE = 'Revenue',
  GUIDED_SELLING = 'Guided Selling',
  INTELLIGENT_DIALER = 'Intelligent Dialer',
  LIVE = 'Live',
  MOMENTS = 'Moments'
}
